// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__KpkSN","text":"SelectPayment_text__1Ueor","title":"SelectPayment_title__1HXeY","btn":"SelectPayment_btn__1rrYG"};